import React from 'react';
import { usePageTranslations } from '../hooks/useTranslation.js';
import Footer from '../components/Footer.jsx';
import { homepageImages } from '../assets/homepage/index.js';

const SectionHeader = ({ title, children }) => (
  <header className="signal-section-header">
    <h2>{title}</h2>
    <div>{children}</div>
  </header>
);

const TeachingPage = () => {
  const t = usePageTranslations('teaching');

  return (
    <div className="min-h-screen bg-bg-main text-text-primary">
      <main className="site-main teaching-page">
        <section className="site-hero teaching-hero">
          <div className="site-hero__copy">
            <h1 className="site-title">{t.hero?.title}</h1>
            <p className="site-lead">{t.hero?.subtitle}</p>
            <p className="site-copy">{t.intro}</p>
          </div>
          <div className="homepage-photo-frame teaching-hero__photo">
            <img src={homepageImages.teamWorkstations} alt="" className="homepage-photo" aria-hidden="true" />
          </div>
        </section>

        <section className="signal-section">
          <SectionHeader title={t.eu_ai_act?.title}>
            <p className="teaching-subtitle">{t.eu_ai_act?.subtitle}</p>
            <p>{t.eu_ai_act?.description}</p>
          </SectionHeader>
          <div className="site-grid site-grid--3">
            {t.eu_ai_act?.benefits?.map((benefit) => (
              <div key={benefit} className="teaching-cell">{benefit}</div>
            ))}
          </div>
          <p className="site-statement">{t.eu_ai_act?.highlight}</p>
        </section>

        <section className="signal-section">
          <SectionHeader title={t.target_groups?.title} />
          <div className="site-row-list">
            {t.target_groups?.groups?.map((group) => (
              <article key={group.title} className="teaching-row teaching-row--group">
                <h3>{group.title}</h3>
                <div>
                  <p>{group.description}</p>
                  <p className="teaching-row__focus">
                    <span>{t.sidebar?.focusLabel}</span> {group.focus}
                  </p>
                </div>
                <div className="signal-service-tags teaching-row__tags">
                  {group.formats?.map((format) => (
                    <span key={format}>{format}</span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="signal-section">
          <SectionHeader title={t.offerings?.title} />
          <div className="site-grid site-grid--3">
            {t.offerings?.categories?.map((category) => (
              <article key={category.title} className="teaching-topics">
                <h3>{category.title}</h3>
                <ul>
                  {category.topics?.map((topic) => (
                    <li key={topic}>{topic}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>

        <section className="signal-section">
          <SectionHeader title={t.workshops?.title}>
            <p>
              <span className="teaching-inline-label">{t.sidebar?.languagesLabel}</span> {t.sidebar?.languagesValue}
            </p>
          </SectionHeader>
          <div className="site-row-list">
            {t.workshops?.formats?.map((format) => (
              <article key={format.title} className="teaching-row teaching-row--format">
                <h3>{format.title}</h3>
                <p className="teaching-row__duration">{format.duration}</p>
                <p>{format.description}</p>
              </article>
            ))}
          </div>
          <div className="site-label-line teaching-benefits" aria-label={t.sidebar?.benefitsTitle}>
            {t.sidebar?.benefits?.map((benefit) => (
              <span key={benefit}>{benefit}</span>
            ))}
          </div>
        </section>

        <section className="signal-section">
          <SectionHeader title={t.expertise?.title} />
          <ul className="teaching-expertise">
            {t.expertise?.items?.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <div className="site-grid site-grid--3 teaching-facts">
            <div className="teaching-topics">
              <h3>{t.sidebar?.specializationTitle}</h3>
              <ul>
                {t.sidebar?.specializationItems?.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="teaching-topics">
              <h3>{t.technologies?.title}</h3>
              <p>{t.technologies?.list}</p>
            </div>
            <div className="teaching-topics">
              <h3>{t.clients?.title}</h3>
              <div className="signal-service-tags">
                {t.clients?.sectors?.map((sector) => (
                  <span key={sector}>{sector}</span>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="site-contact">
          <div>
            <h2 className="site-heading">{t.cta?.title}</h2>
            <p className="finance-cta__lead">{t.cta?.description}</p>
          </div>
          <a href={`mailto:${t.cta?.email}?subject=${encodeURIComponent(t.cta?.subject || '')}`} className="homepage-button-primary">
            {t.cta?.button}
          </a>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TeachingPage;
